import { configureStore } from './configureStore'

/**
 * We're doing this in a file so that when we create a wrapper for
 * mapbox components, we can re-use the same store when using ReactDOM.render()
 */
export const { store, persistor } = configureStore()
